import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { SelectAdoRegion } from './SelectAdoRegionExtension';

export const SelectAdoRegionFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SelectAdoRegion',
    component: SelectAdoRegion,
  }),
);
